<template>
    <md-toolbar
        md-elevation="0"
        class="md-transparent"
        :class="{
            'md-toolbar md-theme-default md-elevation-0':
                $route.meta.navbarAbsolute,
        }"
    >
        <div class="md-toolbar-row">
            <div class="md-toolbar-section-end">
                <md-button
                    class="md-just-icon md-round md-simple md-toolbar-toggle"
                    :class="{ toggled: $sidebar.showSidebar }"
                    @click="toggleSidebar"
                >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </md-button>
            </div>
        </div>
    </md-toolbar>
</template>

<script>
import { isIOS } from "mobile-device-detect";
export default {
    data() {
        return {
            esIOS: isIOS,
            languages: [
                {
                    text: "spanish",
                    key: "es",
                },
                {
                    text: "english",
                    key: "en",
                },
                {
                    text: "dutch",
                    key: "nl",
                },
            ],
        };
    },
    computed: {},
    methods: {
        changeLanguage(e) {
            let language = e.target.getAttribute("data-value");
            this.$i18n.locale = language;
            localStorage.setItem("locale", language);
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        },
    },
};
</script>
